import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import FooterContentFunc from "./footerContent";
import AnchorElement from "../../functions/AnchorElement.jsx";
import deluxeLogo from "../../assets/img/deluxe-logo.png";

import expand_less from "../../assets/icons/expand_less_white.svg";
import expand_more from "../../assets/icons/expand_more_white.svg";

import { I18nContext } from "../../i18n/index";
function Footer() {
  const { translate } = React.useContext(I18nContext);

  const langState = useSelector(state => state.mainReducer.lang, shallowEqual);

  const isMobileState = useSelector(
    state => state.mainReducer.isMobile,
    shallowEqual
  );

  const loginNameState = useSelector(
    state => state.loginReducer.loginName,
    shallowEqual
  );

  const companyNameState = useSelector(
    state => state.loginReducer.companyname,
    shallowEqual
  );

  const customerPropsState = useSelector(
    state => state.loginReducer.customerProps,
    shallowEqual
  );

  const isLoggedIn = Boolean(loginNameState || companyNameState);
  const isBanker = Boolean(
    customerPropsState?.some(
      property =>
        property.key === "User_Type" &&
        property.value?.trim().toLowerCase() === "banker"
    )
  );

  const [footerLinksExpanded, setFooterLinksExpanded] = useState(false);

  const toggleExpandFooterLinks = () => {
    setFooterLinksExpanded(footerLinksExpanded => !footerLinksExpanded);
  };

  const [footerContent, setFooterContent] = useState({});

  useEffect(() => {
    setFooterContent(FooterContentFunc(langState, loginNameState));
    return () => {
      setFooterContent({});
    };
  }, [langState, loginNameState]);

  const links = (
    <div className="footer-links" style={{ marginRight: "auto" }}>
      <p>
        <Link to="/terms-and-conditions">Terms &amp; Conditions </Link>
      </p>
      <p>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </p>
      <p>
        <Link to="/accessibility">Deluxe website accessibility policy</Link>
      </p>
      {isLoggedIn && isBanker && (
        <p>
          <a
            href={`${process.env.PUBLIC_URL || ""}/banker-guide.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Banker Guide
          </a>
        </p>
      )}
    </div>
  );

  const finePrint = (
    <small style={{ color: "#eee", fontSize: "0.8rem", lineHeight: "2rem" }}>
      Copyright © 2021 Deluxe Corporation. All rights reserved.
    </small>
  );
  if (footerContent && Object.keys(footerContent).length > 0) {
    if (isMobileState) {
      return (
        <footer id="footer">
          <div className="new-footer">
            <div className="container">
              <div className="footer-links-cotaniner">
                <button
                  onClick={toggleExpandFooterLinks}
                  className="footer-expand-button"
                >
                  {footerLinksExpanded ? `Collapse` : `Expand`}
                  {footerLinksExpanded ? (
                    <img src={expand_more} alt="expand more"></img>
                  ) : (
                    <img src={expand_less} alt="expand less"></img>
                  )}
                </button>
                <div
                  style={{ display: footerLinksExpanded ? "" : "none" }}
                  className="footer-links-wrapper"
                >
                  {links}
                </div>
              </div>

              <div id="finePrint">
                <div style={{ textAlign: "center" }}>{finePrint}</div>
                <img src={deluxeLogo} alt="Deluxe Corporation" />
              </div>
            </div>
          </div>
        </footer>
      );
    } else {
      return (
        <footer id="footer">
          <div className="new-footer">
            <div id="finePrint">
              {links}
              <img src={deluxeLogo} alt="Deluxe Corporation" />
            </div>
            <div style={{ textAlign: "center" }}>{finePrint}</div>
          </div>
        </footer>
      );
    }
  } else {
    return null;
  }
}

export default Footer;
